import React, { useEffect } from 'react';
import { initializeAnimations } from '../utils/animationObserver';
import cwPhoto from '../img/cw_photo.png';

function AboutMe() {
  useEffect(() => {
    const cleanup = initializeAnimations();
    return cleanup;
  }, []);

  return (
    <section id="about_section" className="py-5 bg-light">
        <div className="content-container">
            <div className="row pb-5 px-4">
                <div className="col-10 col-md-3 slide-right"
                     data-animate>
                    <img className="w-100 mb-4" src={cwPhoto} alt="Clayton Whitehead" />
                </div>
                <div className="col-md-9 slide-left"
                     data-animate>
                    <h2 className="mb-3">The weather up here is quite nice</h2>
                    <p>
                      I'm Clayton, a coffee-fueled designer, problem solver, and an multi-faceted artist. With a background in Graphic Design and Illustration, my creative journey has evolved into the dynamic world of UI/UX and product design.
                    </p>
                    <p>
                      I've had the privilege of leading creative teams that seamlessly bridge design and development, resulting in the creation of meaningful user experiences. My passion for visual art extends across multiple mediums, as I've always been fascinated by the fusion of art and technology.
                    </p>
                    <p>
                      Whether it's through pixels or paint, my goal is clear: to create effective, innovative, and visually captivating solutions.
                    </p>
                    <p>
                      Interested in collaborating or simply want to connect? Drop me a line! 
                      <br />
                    </p>
                    <p className="pt-3">
                      <a className="button-primary" href="mailto:hello@claytonwhitehead.com">hello@claytonwhitehead.com</a>
                    </p>
                </div>
            </div>
        </div>
        <div className="content-container">
            <div className="width-100 c-fix">
                <div className="row skill-columns">
                    <div className="col-md-4 px-4 flip-horizontal delay-1 "
                         data-animate>
                        <h3 className="font-2 text-uppercase">UI/UX & Product Design</h3>
                        <p>Experience building design systems, user flows, and scalable templates built for real business outcomes.</p>
                    </div>
                    <div className="col-md-4 px-4 flip-horizontal delay-2"
                         data-animate>
                        <h3 className="font-2 text-uppercase">Front-End Development</h3>
                        <p>Proficient in HTML5, CSS/SCSS/LESS, and JavaScript, translating design into accessible, production-ready code.</p>
                    </div>
                    <div className="col-md-4 px-4 flip-horizontal delay-3"
                         data-animate>
                        <h3 className="font-2 text-uppercase">Visual & Brand Design</h3>
                        <p>A background in graphic design and illustration that brings craft and polish other product designers often lack</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
  );
}

export default AboutMe